import {Col, Row } from "antd";
import React from "react";
import { PageHeader } from "../../Common/MainLayout";

const SA100Configuration = () => {
  return (
    <>
      <Row justify="start" align="middle" style={{ margin: "1px 15px" }}>
        <PageHeader
          item={[
            {
              label: "SA100 Configuration",
              path: "/sa100configuration",
              style: { color: "black" },
            },
          ]}
          style={{ color: "#172B4D" }}
        />
      </Row>
      <Row
        className="roundedCornerSmall px-3 py-1"
        style={{ backgroundColor: "white" }}
      >
        <Col
          className="pt-3"
          span={24}
          style={{
            minHeight: window.innerHeight - 200,
            fontSize: 18,
            fontWeight: 600,
          }}
        >
          SA100 Configuration page is in progress...
        </Col>
      </Row>
    </>
  );
};

export default SA100Configuration;
